import { invalidateSingleEntryCache } from 'api/urql/helpers/mutation';

export const mergeVenues = (results, args, cache, _info) => {
  // handlers go here
  args.venueIds
    .filter((id) => id !== args.mergeVenueId)
    .forEach((venueId) => {
      invalidateSingleEntryCache('Venue', 'id')(
        results,
        { id: venueId },
        cache
      );
    });
};
